module.exports = __webpack_public_path__ + "img/image (1).5817423b.webp";